import {getCompanyReports, getReportTitles} from '@/helpers/api/reports'
const listingColumns = localStorage.getItem('reports_columns')

const messagesStore = {
  namespaced: true,
  state: {
		listingColumns: listingColumns ? JSON.parse(listingColumns):{
			serial: true,
			client: true,
			details: true,
			project: true,
			status: true,
			actions: true
		},
		scrolledReport: 0,
		reportHeaderHeight: 0,
		reportSecondHeaderHeight: 0,
		newReportTitleModal: false,
		newReportTitleModalEditing: null,
		loadingReportTitles: false,
		companiesReportTitles: [],
		companyReports: [],
		companyReportsCount: 0,
		companyReportsLastId: null,
		reportPdfModal: null,
		reportEditorRef: null,
		confirmNewReportModal: null,
		loadingCompanyReports: false,
		reportComponentModalId: [],
		reportModalId: null
  },
  mutations: {
    setListingColumns(state, listingColumns) {
      state.listingColumns = listingColumns
			localStorage.setItem('reports_columns', JSON.stringify(listingColumns))
    },
		setScrolledReport(state, value) {
			state.scrolledReport = value
		},
		setReportHeaderHeight(state, value) {
			state.reportHeaderHeight = value
		},
		setReportSecondHeaderHeight(state, value) {
			state.reportSecondHeaderHeight = value
		},
		setNewReportTitleModal(state, value){
			state.newReportTitleModal = value
		},
		setNewReportTitleModalEditing(state, value){
			state.newReportTitleModalEditing = value
		},
		setLoadingReportTitles(state, value){
			state.loadingReportTitles = value
		},
		setCompaniesReportTitles(state, value){
			state.companiesReportTitles = value
		},
		setLoadingCompanyReports(state, value){
			state.loadingCompanyReports = value
		},
		setCompanyReports(state, value){
			state.companyReports = value
		},
		setCompanyReportsCount(state, value){
			state.companyReportsCount = value
		},
    setCompanyReportsLastId(state, contract_id) {
      state.companyReportsLastId = contract_id
    },
		setReportPdfModal(state, pdf) {
			state.reportPdfModal = pdf
		},
		setReportEditorRef(state, value){
			state.reportEditorRef = value
		},
		setConfirmNewReportModal(state, value){
			state.confirmNewReportModal = value
		},
		// setReportComponentModalId(state, value){
		// 	const {status, report_id} = value
		// 	state.reportComponentModalId = value
		// },
		setReportComponentModalId(state, { status, report_id, close_last_openned, close_all }) {
			if (!Array.isArray(state.reportComponentModalId)) {
				state.reportComponentModalId = []
			}

			if (close_all) {
				state.reportComponentModalId = []
				return
			}

			if (close_last_openned) {
				state.reportComponentModalId.pop()
				return
			}

			if (status) {
				if (!state.reportComponentModalId.includes(report_id)) {
					state.reportComponentModalId.push(report_id)
				}
			} else {
				state.reportComponentModalId = state.reportComponentModalId.filter(id => id !== report_id)
			}
		},
		setReportModalId(state, value){
			state.reportModalId = value
		}
  },
  actions: {
    async getReportTitles({ commit }) {
      commit('setLoadingReportTitles', true)
      const data = {
        start: 0,
        limit: 300
      }
      const titles = await getReportTitles(data)
      if (titles.code === 200) {
        commit('setCompaniesReportTitles', titles.company_report_titles)
      }
      commit('setLoadingReportTitles', false)
    },
    async getCompanyReports({ commit }, {search = null, start = 0, limit = 20, order_by = 1} = {}) {
      commit('setLoadingCompanyReports', true)
      const data = {
				search,
        start,
        limit,
				order_by
      }
      const reports = await getCompanyReports(data)
      if (reports.code === 200) {
        commit('setCompanyReports', reports.reports)
        commit('setCompanyReportsLastId', reports.last_report_id)
				commit('setCompanyReportsCount', reports.reports_count)
      }
      commit('setLoadingCompanyReports', false)
    },
  }
}

export default messagesStore
